import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white hover:shadow-md transition-shadow" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-7">
        <span className="font-semibold text-gray-900 pr-4" data-id="element-8">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-9">
          <ChevronDown className="w-5 h-5 text-indigo-600" data-id="element-10" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-11">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-12">
            <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-13">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}